import styled from 'styled-components';
import { Modal } from '@prosolve/common-components-ui'

const Content = styled.div`
`

const CoverImageWrapper = styled.div`
  /* display: flex; */
`
const CoverImage = styled.img`
  display: block;
  width: 100%;
  height: calc(100vh - 230px);
  object-fit: contain;
`

export default ({
  onClose,
  assessmentName
}) => {

  const clueUrl = assessmentName === 'PD-Challenge1'
    ? 'https://api.go.prosolve.com/api/file/pdExperienceThumbnails/human%20clue.png'
    : assessmentName === 'PD-Challenge3' 
    ? 'https://api.go.prosolve.com/api/file/pdExperienceThumbnails/driven%20clue.png'
    : assessmentName === 'PD-Challenge4' 
    ? 'https://api.go.prosolve.com/api/file/pdExperienceThumbnails/experiential%20clue.png'
    : ''

  return (
    <Modal isDark={true} isFullScreen={false} isAutoHeight={false} isAutoWidth={false} closeOnOffClick={true} onClose={onClose}>
      <Content>
        <CoverImageWrapper>
          <CoverImage src={clueUrl} alt={`image-cover-clue`}/>
        </CoverImageWrapper>
      </Content>
    </Modal>
  )
}